import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.image-gallery').forEach((gallery) => {

        const slider = gallery.querySelector('.gallery-slider');
        if (!slider) {return;}

        const uniqueId = gallery.id;

        const swiper = new Swiper(slider, {
            slidesPerView: 1,
            speed: 600,
            pagination: {
                el: gallery.querySelector('.ig-pagination-' + uniqueId),
                clickable: true,
            },
            navigation: {
                nextEl: gallery.querySelector('.swiper-button-next-' + uniqueId),
                prevEl: gallery.querySelector('.swiper-button-prev-' + uniqueId),
            },

            breakpoints: {
                1200: { slidesPerView: 'auto', spaceBetween: 32 },
                768: { slidesPerView: 'auto', spaceBetween: 32, centeredSlides: true, loop: true, speed: 1500 },
                0: { slidesPerView: 'auto', spaceBetween: 16, centeredSlides: true, loop: true, speed: 1500 },
            },

            on: {
                init() { updateGalleryWidths(gallery); },
                imagesReady() { updateGalleryWidths(gallery); },
                resize() { updateGalleryWidths(gallery); },
            },
        });

        gallery.querySelectorAll('.gallery-card').forEach((card) => {
            card.addEventListener('mouseenter', () => {
                setTimeout(() => {
                    updateGalleryWidths(gallery);
                    swiper.update();
                }, 50);
            });

            card.addEventListener('mouseleave', () => {
                setTimeout(() => {
                    updateGalleryWidths(gallery);
                    swiper.update();
                }, 50);
            });
        });

        setTimeout(() => {
            updateGalleryWidths(gallery);
            swiper.update();
        }, 700);

    }); // end foreach
});


// ---- Helper Functions (same as yours but scoped) ----

async function waitForImageReady(img) {
    return new Promise((resolve) => {
        if (!img) {return resolve(null);}
        if (img.complete && (img.naturalWidth || img.naturalHeight)) {return resolve(img);}
        if (img.decode) {
            img.decode().then(() => resolve(img)).catch(() => {
                img.addEventListener('load', () => resolve(img), { once: true });
                img.addEventListener('error', () => resolve(img), { once: true });
            });
            return;
        }
        img.addEventListener('load', () => resolve(img), { once: true });
        img.addEventListener('error', () => resolve(img), { once: true });
    });
}

async function measureCard(card) {
    const img = card.querySelector('.gallery-imgwrap img');
    if (!img) {return;}

    await waitForImageReady(img);

    const rect = card.getBoundingClientRect();
    const cw = Math.round(rect.width || 217);
    const ch = Math.round(rect.height || 350);

    const nw = img.naturalWidth;
    const nh = img.naturalHeight;

    const scale = Math.max(cw / nw, ch / nh);
    const displayW = Math.round(nw * scale);

    card.style.setProperty('--widthOriginal', displayW + 'px');
    card.style.flex = '0 0 217px';
}

async function updateGalleryWidths(gallery) {
    const cards = [...gallery.querySelectorAll('.gallery-card')];
    if (!cards.length) {return;}

    await Promise.all(cards.map(measureCard));

    requestAnimationFrame(() => {
        setTimeout(() => cards.forEach(measureCard), 100);
    });
}
